import { infoColor, infoBoxShadow } from '../global';

const adminSettingCustomItemStyle = {
    custom: {
        justifyContent: 'center',
        marginTop: '20px',
    },
    customSite: {
        marginBottom: '20px',
    },
    fieldset: {
        borderColor: infoColor,
        borderRadius: '8px',
        ...infoBoxShadow,
        padding: '26px',
    },
    customFooter: {
        marginBottom: '20px',
        marginTop: '20px',
    },
    customButton: {
        width: '150px',
    },
    customButtonReset: {
        width: '150px',
        margin: '0 20px',
    },
    customFooterButton: {
        textAlign: 'end',
    },
};

export default adminSettingCustomItemStyle;
